import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { BannersDataService, BannersColumnsService } from '../../../services';
import { Banner, BannersResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-banner-form',
  templateUrl: './banner-form.component.html',
  styleUrls: ['./banner-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class BannerFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public banner: Banner = {};
  public bannerForm: FormGroup = new FormGroup({});
  public banners: Banner[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private bannersDataService: BannersDataService,
    public bannersColumnsService: BannersColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'BannerFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Banner - Edit');
        this.getBanner(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.banner !== 'undefined') {
      this.banner = this.dynamicDialogConfig.data.banner;
    }
    if (typeof this.banner.id === 'undefined' || this.banner.id === null) {
      this.banner.id = null;
      this.banner.closable = false;
      this.banner.autoPublishing = false;
      this.banner.startPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.banner.endPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
    }
    this.getBanners();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'BannerFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'BannerFormComponent');
  }

  getBanner(id: number): void {
    this.isLoading = true;
    this.bannersDataService.getBanner(id).subscribe((response: Banner|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.banner = response;
        this.prepareFrom();
      }
    });
  }

  getBanners(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.banners !== 'undefined' && this.dynamicDialogConfig.data.banners.length > 0) {
      this.banners = this.dynamicDialogConfig.data.banners;
      return;
    }
    this.bannersDataService.getBanners(this.parameters).subscribe((response: BannersResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.banners = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.banner.startPublishing = moment(this.banner.startPublishing).toDate();
    this.banner.endPublishing = moment(this.banner.endPublishing).toDate();
    this.bannerForm = new FormGroup({
      name: new FormControl(this.banner.name, [Validators.required, ]),
      bannerType: new FormControl((typeof this.banner.bannerType === 'number') ? this.banner.bannerType : this.banner.bannerType?.id, [Validators.required, ]),
      picture: new FormControl(this.banner.picture, []),
      closable: new FormControl(this.banner.closable, []),
      countDown: new FormControl(this.banner.countDown, []),
      webAction: new FormControl(this.banner.webAction, [Validators.required, ]),
      androidAction: new FormControl(this.banner.androidAction, [Validators.required, ]),
      iphoneAction: new FormControl(this.banner.iphoneAction, [Validators.required, ]),
      gender: new FormControl(this.banner.gender, []),
      priority: new FormControl(this.banner.priority, []),
      minAge: new FormControl(this.banner.minAge, []),
      maxAge: new FormControl(this.banner.maxAge, []),
      webUrl: new FormControl(this.banner.webUrl, []),
      phoneNumberToCall: new FormControl(this.banner.phoneNumberToCall, []),
      smsMobileNumber: new FormControl(this.banner.smsMobileNumber, []),
      smsBody: new FormControl(this.banner.smsBody, []),
      emailAdress: new FormControl(this.banner.emailAdress, []),
      emailSubject: new FormControl(this.banner.emailSubject, []),
      emailBody: new FormControl(this.banner.emailBody, []),
      androidAppUrl: new FormControl(this.banner.androidAppUrl, []),
      iphoneAppUrl: new FormControl(this.banner.iphoneAppUrl, []),
      youtubeUrl: new FormControl(this.banner.youtubeUrl, []),
      mapLatitude: new FormControl(this.banner.mapLatitude, []),
      mapLongitude: new FormControl(this.banner.mapLongitude, []),
      screen: new FormControl(this.banner.screen, []),
      screenParameters: new FormControl(this.banner.screenParameters, []),
      template: new FormControl(this.banner.template, []),
      adText: new FormControl(this.banner.adText, []),
      textColor: new FormControl(this.banner.textColor, []),
      backgroundColor: new FormControl(this.banner.backgroundColor, []),
      totalHits: new FormControl(this.banner.totalHits, []),
      todayHits: new FormControl(this.banner.todayHits, []),
      totalClicks: new FormControl(this.banner.totalClicks, []),
      todayClicks: new FormControl(this.banner.todayClicks, []),
      status: new FormControl(this.banner.status, [Validators.required, ]),
      autoPublishing: new FormControl(this.banner.autoPublishing, [Validators.required, ]),
      startPublishing: new FormControl(this.banner.startPublishing, []),
      endPublishing: new FormControl(this.banner.endPublishing, []),
      startPublishingTime: new FormControl(this.banner.startPublishingTime, []),
      endPublishingTime: new FormControl(this.banner.endPublishingTime, []),
      maxClicksPerDay: new FormControl(this.banner.maxClicksPerDay, []),
      maxTotalClicks: new FormControl(this.banner.maxTotalClicks, []),
      maxHitsPerDay: new FormControl(this.banner.maxHitsPerDay, []),
      maxTotalHits: new FormControl(this.banner.maxTotalHits, []),
      id: new FormControl(this.banner.id, []),
      bannerPositions: new FormControl(((typeof this.banner.bannerPositions === 'undefined') ? [] : this.banner.bannerPositions as any[]).map((item: any) => { return (typeof item === 'number') ? item : item.id; }), []),
    });
  }

  list() {
    this.router.navigate(['/banners']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.bannerForm.controls).forEach((field: any) => {
        const control = this.bannerForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.bannerForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.banner = this.bannerForm.value;
    this.disableSubmit = true;
    console.log('banner', this.banner);
    if (typeof this.banner.id !== 'undefined' && this.banner.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.bannersDataService.updateBanner(this.banner).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('BANNERUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('BANNERNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.bannersDataService.addBanner(this.banner).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('BANNERCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('BANNERNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  toggleAllBannerPositions(event: any) {
    const control = this.bannerForm.get('bannerPositions');
    if (control !== null) {
      if (event.checked)  {
        control.setValue(this.bannersColumnsService.bannerPositionsFiltered.map((item: any) => { return item.id; }));
      } else {
        control.setValue([]);
      }
    }
  }

  setTextColor(event: any) {
    const control = this.bannerForm.get('textColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }

  setBackgroundColor(event: any) {
    const control = this.bannerForm.get('backgroundColor');
    if (control !== null) {
      control.setValue(event.value);
    }
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.bannerForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'banners',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.bannerForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-banner-form',
  templateUrl: './banner-form.component.html',
  styleUrls: ['./banner-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogBannerFormComponent extends BannerFormComponent {
}

